// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"769886e2","453":"eae1046e"}[chunkId] + ".chunk.js";
};